import React from "react"

type ProductLocationProps = {
  location: {
    address_1: string
    address_2: string
    city: string
    country: string
    postal_code: string
    state: string
    phone: string
    email: string
    website: string
    latitude: string
    longitude: string
    address_type: string
    type?: string
  }
}

export const ProductLocation = ({ location }: ProductLocationProps) => {
  const { address_1, address_2, city, country, postal_code, state } = location
  const formattedAddress = `${address_1}${
    address_2 ? `, ${address_2}` : ""
  }, ${city}, ${state}, ${postal_code.toUpperCase()}, ${country}`
  return (
    <p className={"text-neutral-1000 text15Regular"}>
      <span className={"!text-neutral-1000 text15Medium"}>
        {location.type === "office" ? "Office Location: " : "Redeem Point: "}
      </span>
      <span className={"block sm:inline mt-1 sm:mt-0"}>{formattedAddress}</span>
    </p>
  )
}
